module.exports = __webpack_public_path__ + "img/4_clubs.8efdf790.png";